import { SidebarPortal } from "@/features/Navigation/components/SidebarPortal";
import { showCompanyListAtom } from "../CompaniesLayout";
import { useAtom } from "jotai";
import { FileList } from "@/features/Labeling/components/FileList";
import clsx from "clsx";
import { useSelectedFile } from "@/features/Labeling/hooks/useSelectedFile";
import { motion } from "framer-motion";
import { AccountPanel } from "@/features/Labeling/components/AccountPanel/AccountPanel";
import { RightDrawerContent } from "@/features/Navigation/components/RightDrawerContent";
import { FileView } from "@/features/Labeling/components/FileView/FileView";
import { useRowSelection } from "@/features/Labeling/hooks/useRowSelection";
import { FileHeading } from "@/features/Labeling/components/FileHeading";
import { showCommitPanelAtom } from "@/features/Labeling/Labeling.state";
import { DraftCommitPanel } from "@/features/Labeling/components/DraftCommitPanel/DraftCommitPanel";
import { useDraft } from "@/features/Labeling/hooks/useDraft";
import { LabelingEmptyState } from "@/features/Labeling/components/LabelingEmptyState";
import { useLabelingEmptyState } from "@/features/Labeling/hooks/useLabelingEmptyState";

export default function LabelingUI() {
    const [showCompanyList] = useAtom(showCompanyListAtom);
    const [showCommitPanel, setShowCommitPanel] = useAtom(showCommitPanelAtom);
    const { selectedFileId } = useSelectedFile();
    const { selectedAccountRow, setSelectedAccountRow } = useRowSelection();
    const { isReadonly, draft } = useDraft();
    useLabelingEmptyState();

    return (
        <>
            <div>
                {!showCompanyList && (
                    <SidebarPortal>
                        <FileList />
                    </SidebarPortal>
                )}

                {selectedAccountRow && (
                    <RightDrawerContent
                        onClose={() => setSelectedAccountRow(null)}
                    >
                        <AccountPanel />
                    </RightDrawerContent>
                )}

                {showCommitPanel && (
                    <RightDrawerContent
                        onClose={() => setShowCommitPanel(false)}
                    >
                        <DraftCommitPanel />
                    </RightDrawerContent>
                )}
            </div>
            <motion.div className="flex size-full">
                <div
                    className={clsx("size-full px-6", "flex flex-col", "gap-3")}
                >
                    {!selectedFileId && <LabelingEmptyState />}
                    {!isReadonly && !draft.data && draft.isError && (
                        <div>
                            Draft 404 - Check if draft was converted to a
                            labeled file
                        </div>
                    )}
                    <FileHeading />
                    <FileView />
                </div>
            </motion.div>
        </>
    );
}
